var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFillContain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "accent",
    d: "M16.2 12.5H3.14c-.26 0-.46-.19-.46-.42V2.92c0-.23.2-.42.46-.42H16.2c.25 0 .46.19.46.42v9.16c0 .23-.21.42-.46.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.67 1.75a.75.75 0 0 0-.75.75v14c0 .41.33.75.75.75h14c.41 0 .75-.34.75-.75v-14a.75.75 0 0 0-.75-.75h-14Zm.75 10.01V3.25h12.5v8.5h-.46a.75.75 0 0 0 0 1.5h.46v2.5H3.42v-2.49h.45a.75.75 0 1 0 0-1.5h-.45Zm9.73 1.5a.75.75 0 1 0 0-1.5h-2.32a.75.75 0 1 0 0 1.5h2.32Zm-4.64 0a.75.75 0 0 0 0-1.5H6.19a.75.75 0 1 0 0 1.5H8.5Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillContain);
export default __webpack_public_path__ + "static/media/fillContain.af30283eb339a5bc944093d8c5c8ec15.svg";
export { ForwardRef as ReactComponent };